import * as Tgcc from '../tgccGlobal';
import * as React from 'react';
import Radium, { StyleRoot } from 'radium';
import {CSSProperties} from 'react';

type CardProps = {
    title: string;
    children?: any;
    height?:string;
}

const wrapperStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: Tgcc.Styles.cardBackground,
    fontFamily: 'CenturyGothic',
    boxShadow: Tgcc.Styles.boxShadow,
    textTransform: 'uppercase',
    margin: '15px 10px',
    width:'340px',
    alignSelf:'center'
};

const titleStyle: CSSProperties = {
    height: '25px',
    lineHeight: '25px',
    fontFamily: 'Rosewood',
    fontSize: '15px',
    letterSpacing: '1px',
    alignSelf: 'center',
    margin: '5px'
};

const contentStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '300px',
    width: '300px',
    margin: '0 20px 20px 20px',
    border: Tgcc.Styles.singleBorder,
    overflowX: 'hidden',
    overflowY: 'auto',
    '@media (max-width:320px)': {
        width:'260px'
    }
};

class _DashboardCard extends React.Component<CardProps, any>{
    componentWillMount(){
        if(this.props.height){
            contentStyle.height = this.props.height || contentStyle.height;
        }
    }
    
    render(){
        return (
            <div style={wrapperStyle}>
                <div style={titleStyle}>
                    {this.props.title}
                </div>
                <div style={contentStyle}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}
export var DashboardCard = Radium(_DashboardCard);